type ThumbsDownIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const ThumbsDownIcon = (props: ThumbsDownIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_11787_85475)">
      <path
        d="M11.3334 1.33423H13.1134C13.4907 1.32755 13.8573 1.45965 14.1436 1.70544C14.43 1.95123 14.6161 2.2936 14.6667 2.66756V7.33423C14.6161 7.70819 14.43 8.05056 14.1436 8.29635C13.8573 8.54214 13.4907 8.67423 13.1134 8.66756H11.3334M6.66669 10.0009V12.6676C6.66669 13.198 6.8774 13.7067 7.25247 14.0818C7.62755 14.4568 8.13625 14.6676 8.66669 14.6676L11.3334 8.66756V1.33423H3.81335C3.4918 1.33059 3.17977 1.44329 2.93475 1.65155C2.68973 1.85982 2.52824 2.14962 2.48002 2.46756L1.56002 8.46756C1.53102 8.65865 1.5439 8.85377 1.59779 9.03939C1.65168 9.22501 1.74529 9.3967 1.87211 9.54255C1.99894 9.6884 2.15597 9.80494 2.33231 9.88408C2.50864 9.96322 2.70008 10.0031 2.89335 10.0009H6.66669Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11787_85475">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
